import AbstractField from './abstract'

class PasswordField extends AbstractField{
    __init_dom_schema(){
        return {
            // icon: '.js-form-field__icon',
            icon: {
                selector: '.js-form-field__icon',
                actions: {
                    'click': this.changeVisibility.bind(this)
                }
            },
            input: {
                selector: 'input',
                actions: {
                    'input': this.changed.bind(this)
                }
            },
        }
    }
    __init(){
        // this.registerEvents('changed')
        // this.dom.icon.addEventListener('click', this.changeVisibility.bind(this));
    }
    changeVisibility(){
        this.node.classList.toggle('is--active')
        const is_visible = this.node.classList.contains('is--active')
        this.dom.input.type = is_visible ? 'text' : 'password'
    }
    changed(){
        this.dispatchEvent('changed')
    }
    isRequired(){
        return this.dom.input.hasAttribute('required')
    }
    isFilled(){
        return this.dom.input.value !== ''
    }
    getValue(){
        return this.dom.input.value
    }
}

export default PasswordField